<div class="error-page">
  <ng-container [ngSwitch]="error">
    <div *ngSwitchCase="'404'" class="message-wrapper">
      <img src="assets/bookings-empty-list.svg" class="error-img"/>
      <p class="message">Requested resource does not exist</p>
    </div>
    <div *ngSwitchDefault class="message-wrapper">
        <img src="assets/bookings-empty-list.svg" class="error-img"/>
        <p class="message">{{error}}</p>
      </div>
  </ng-container>
</div>
